export const LOCALES = {
  ENGLISH: "en-US",
  UKRAINIAN: "uk-UA",
  SPANISH: "es-ES"
}
